// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_iy-6";
export var emphasizeQuantity = "_iy-3";
export var flatBottomCorners = "_iy-5";
export var productImage = "_iy-0";
export var quantityContainer = "_iy-2";
export var tooltip = "_iy-1";
export var wrapAndEllipsesOverflow = "_iy-4";